<template>
  <div>
    <v-layout wrap justify-center>
      <v-flex xs12 sm6 class="align-self-center" style="background-color:#63028F">
        <v-layout wrap justify-center>
          <v-flex xs12>
            <v-img src="./../../assets/images/loginast.png" height="100vh" cover></v-img>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex pt-12 xs12 sm6 class="align-self-start">
        <v-layout wrap justify-center>
          <v-flex>
            <AppLogin v-if="winStep==0" v-bind:pageData="pageData" @stepper="winStepper" />
            <LoginVerify
              v-if="winStep==1"
              v-bind:pageData="pageData"
              @stepper="winStepper"
              v-bind:lastPage="lastPage"
            />
            <SignUp
              v-if="winStep==2"
              v-bind:pageData="pageData"
              @stepper="winStepper"
              v-bind:lastPage="lastPage"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import AppLogin from "./../Login/loginForm";
import LoginVerify from "./../Login/loginVerify";
import SignUp from "./../Login/signUp";
export default {
  components: {
    AppLogin,
    LoginVerify,
    SignUp,
  },
  data() {
    return {
      winStep: 0,
      phone: null,
      pageData: {},
      lastPage: null,
    };
  },
  beforeMount() {
    if (this.$route.params.lastPage)
      this.lastPage = this.$route.params.lastPage;
  },
  methods: {
    winStepper(window_data) {
      this.winStep = window_data.winStep;
      this.pageData.phone = window_data.phone;
      if (window_data.response)
        this.pageData.pageResponse = window_data.response;
    },
  },
};
</script>